const API_URL = '/api/historialcompras';

/**
 * Obtiene la lista de todas las cabeceras de compras registradas.
 */
export const getHistorialCompras = async () => {
    try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error('Error al obtener el historial de compras');
        return await response.json();
    } catch (error) {
        console.error("CompraService - getHistorialCompras:", error);
        return [];
    }
};

/**
 * Obtiene el detalle de artículos de una compra específica por su ID.
 * @param {number|string} idCompra 
 */
export const getDetalleCompra = async (idCompra) => {
    try {
        const response = await fetch(`${API_URL}?id=${idCompra}`);
        if (!response.ok) throw new Error('Error al obtener el detalle de la compra');
        return await response.json();
    } catch (error) {
        console.error("CompraService - getDetalleCompra:", error);
        return [];
    }
};

